import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://buildforged.com";

export const Seo = ({ title, description, path = "/", image = `${SITE}/og-image.png` }) => {
  const url = `${SITE}${path}`;
  const full = title ? `${title} · BuildForged` : "BuildForged — AI Website Studio for Agencies";
  return (
    <Helmet>
      <title>{full}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="BuildForged" />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};
